var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4658 0.461548H1.32579C1.17329 0.461548 1.02704 0.522128 0.919207 0.629961C0.811374 0.737795 0.750793 0.884048 0.750793 1.03655L0.750793 14.1765C0.750793 14.329 0.811374 14.4753 0.919207 14.5831C1.02704 14.691 1.17329 14.7515 1.32579 14.7515H14.4658C14.6183 14.7515 14.7645 14.691 14.8724 14.5831C14.9802 14.4753 15.0408 14.329 15.0408 14.1765V1.03655C15.0408 0.884048 14.9802 0.737795 14.8724 0.629961C14.7645 0.522128 14.6183 0.461548 14.4658 0.461548V0.461548ZM13.8908 1.61255V5.29555H1.90179V1.61255H13.8908ZM9.07579 9.34255H1.90179V6.44255H9.07579V9.34255ZM1.90179 10.4935H9.07579V13.6015H1.90179V10.4935ZM10.2268 13.6015V6.44655H13.8908V13.6015H10.2268Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.9a65552b.svg";
export { ForwardRef as ReactComponent };